import React, { useState } from "react";
import {
    Box,
    Card,
    CardContent,
    Typography,
    Tooltip,
    Grid,
    Button,
    Collapse,
    Radio
} from "@mui/material/";
import { helpers, format } from "../../../../../common/lib";
import { strings } from "../../../../../common/i18n";

import CheckCircleIcon from "@mui/icons-material/CheckCircle";

const MatchCard = ({
    data = {},
    selected = false,
    onClick,
    minHeight = 120,
    collapseAfter = 4,
    matchFields = [],
    showRadio = false
}) => {
    const [expanded, setExpanded] = useState(false);

    const entries = Object.entries(data).filter(([_, value]) => value);
    const visibleEntries = expanded ? entries : entries.slice(0, collapseAfter);

    return (
        <Card
            variant="outlined"
            sx={{
                mb: 1.5,
                borderRadius: 2,
                backgroundColor: selected ? "#e3f2fd" : "#f9f9f9",
                borderColor: selected ? "primary.main" : "divider",
                cursor: onClick ? "pointer" : "default",
                // minHeight,
                position: "relative",
                px: 1.2,
                pt: 1,
                pb: 1.2
            }}
            onClick={onClick}
        >
            <Box
                sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-start",
                    mb: 0.5
                }}
            >
                {showRadio && (
                    <Radio
                        checked={selected}
                        sx={{
                            p: 0.5,
                            mr: 1
                        }}
                    />
                )}

                <CardContent
                    sx={{
                        py: 0,
                        px: 0,
                        flexGrow: 1,
                        "&:last-child": { pb: 0 }
                    }}
                >
                    <Grid container spacing={0.5}>
                        {visibleEntries.map(([key, value]) => {
                            const isMatch =
                                matchFields.includes(key) ||
                                matchFields.includes(value);
                            const highlightStyle = isMatch
                                ? {
                                      fontWeight: 600,
                                      bgcolor: "primary.main",
                                      color: "white",
                                      px: 0.5,
                                      borderRadius: 1
                                  }
                                : {};

                            return (
                                <Grid
                                    item
                                    xs={6}
                                    key={key}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center"
                                    }}
                                >
                                    <Tooltip title={value}>
                                        <Typography
                                            variant="caption"
                                            sx={{
                                                textTransform: "capitalize",
                                                lineHeight: 1.4,
                                                display: "inline-flex",
                                                alignItems: "center",
                                                maxWidth: "100%",
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                                whiteSpace: "nowrap"
                                            }}
                                        >
                                            <strong>{key}:</strong>&nbsp;
                                            <Box
                                                component="span"
                                                sx={{
                                                    ...highlightStyle,
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                    whiteSpace: "nowrap",
                                                    maxWidth:
                                                        "calc(100% - 24px)"
                                                }}
                                            >
                                                {value}
                                            </Box>
                                            {matchFields.includes(key) && (
                                                <CheckCircleIcon
                                                    fontSize="inherit"
                                                    color="success"
                                                    sx={{ ml: 0.5 }}
                                                />
                                            )}
                                        </Typography>
                                    </Tooltip>
                                </Grid>
                            );
                        })}
                    </Grid>

                    {entries.length > collapseAfter && (
                        <Button
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                setExpanded(!expanded);
                            }}
                            sx={{
                                mt: 0.5,
                                fontSize: "0.7rem",
                                textTransform: "none",
                                pl: 0
                            }}
                        >
                            {expanded ? "Show less" : "Show more"}
                        </Button>
                    )}
                </CardContent>
            </Box>
        </Card>
    );
};

export default MatchCard;
